export const rewardsHero = {
  title: "Get up to 4.2% yearly rewards on your balance",
  subtitle: "",
};
